module.exports = __webpack_public_path__ + "static/images/group-sprites.a17d909.png";